import { robot6 } from './logoMakerIcons';
import { shape16 } from './logoMakerShapes';

/**
 * The default state of the logo maker editor if no logo has been selected in the gallery
 */
const logoMakerDefaultState = {
  mainText: {
    text: 'Gamer name',
    coords: {
      position: { x: 270.1000061035156, y: 482.4000244140625 },
      pivot: { x: 200.68881225585938, y: 73.56640625 },
    },
    fontFamily: 'Days One',
    color: '#333333',
    fontSize: '54',
    outline: { enable: true, stroke: '#A4DD00', strokeThickness: '16' },
  },
  sloganText: {
    coords: {
      position: { x: 394.8999938964844, y: 399.20001220703125 },
      pivot: { x: 45.744659423828125, y: 26.758758544921875 },
    },
    text: '',
    fontFamily: 'Covered By Your Grace',
    color: '#A4DD00',
    shadow: { enable: true, color: '#333333', x: '4', y: '3', blur: '6' },
  },
  background: { enableColor: true, color: '#1212a0' },
  frame: { image: '', scale: '42', color: '#f2f2f2', alpha: '100' },
  logo: {
    logo: robot6,
    coords: {
      position: { x: 294.8999938964844, y: 261.6000061035156 },
      pivot: { x: 291.0848083496094, y: 331.43359375 },
    },
    scale: '49',
    outline: { enable: true, color: '#ffa300', width: '8' },
  },
  shapeImage: {
    image: shape16,
    color: '#007aff',
    coords: {
      position: { x: 458.1000061035156, y: 140.80001831054688 },
      pivot: { x: 456.5000305175781, y: 105.60003662109375 },
    },
    opacity: '100',
    scale: '31',
  },
};

export default logoMakerDefaultState;
